export const UPSERT_SENDER_ATTRIBUTES_CONSTANT = {
  sourceCountry: {
    type: 'select',
    key: 'source_country',
    label: 'Sender Country',
  },
  firstName: {
    type: 'text',
    key: 'first_name',
    label: 'Sender First Name',
  },
  middleName: {
    type: 'text',
    key: 'middle_name',
    label: 'Sender Middle Name',
  },
  lastName: {
    type: 'text',
    key: 'last_name',
    label: 'Sender Last Name',
  },
  nationality: {
    type: 'select',
    key: 'nationality',
    label: 'Sender Nationality',
  },
  gender: {
    type: 'select',
    key: 'gender',
    label: 'Gender',
  },
  password: {
    type: 'password',
    key: 'password',
    label: 'Password',
  },
  dob: {
    type: 'date',
    key: 'date_of_birth',
    label: 'Sender Date of Birth',
  },
  docType: {
    type: 'select',
    key: 'document_type',
    label: 'ID Type',
  },
  docSection: {
    type: 'select',
    key: 'document_section',
    label: 'ID Section',
  },
  docNumber: {
    type: 'text',
    key: 'document_number',
    label: 'ID Number',
  },
  docExpiryDate: {
    type: 'date',
    key: 'document_expiry_date',
    label: 'ID Expiry Date',
  },
  image: {
    type: 'file',
    key: 'image',
    label: 'ID Document Scan',
  },
  address1: {
    type: 'text',
    key: 'address1',
    label: 'Sender Address 1',
  },
  address2: {
    type: 'text',
    key: 'address2',
    label: 'Sender Address 2',
  },
  city: {
    type: 'text',
    key: 'city',
    label: 'Sender City',
  },
  postalCode: {
    type: 'text',
    key: 'postal_code',
    label: 'Sender Postcode',
  },
  email: {
    type: 'email',
    key: 'email',
    label: 'Sender Email',
  },
  mobileCode: {
    type: 'text',
    key: 'mobile_code',
  },
  mobileNumber: {
    type: 'tel',
    key: 'mobile_number',
    label: 'Sender Mobile',
  },
} as const;

export const GENDER = [
  {
    name: 'Male',
    value: 'M',
  },
  {
    name: 'Female',
    value: 'F',
  },
];

export const DOCUMENT_TYPE = [
  {
    name: 'Passport',
    value: 'PASSPORT',
  },
  {
    name: 'Driving Licence',
    value: 'DRIVERS_LICENSE',
  },
  {
    name: 'UK Residence permit',
    value: 'RESIDENCE_PERMIT',
  },
  {
    name: 'National identity card(with photo)',
    value: 'ID_CARD',
  },
];

export const DOCUMENT_SECTION = [
  {
    name: 'Document Front',
    value: 'document-front',
  },
  {
    name: 'Document Back',
    value: 'document-back',
  },
  {
    name: 'Selfie',
    value: 'selfie',
  },
];
